import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  setConfirmModal: (value: boolean) => void
  saveEmployees: () => void
}

const ConfirmModal = ({ setConfirmModal, saveEmployees }: Props) => {
  return (
    <Modal
      title={i18n.t('payroll_integrations.incidences.datev_lauds.import.modals.confirm.title')}
      description={i18n.t(
        'payroll_integrations.incidences.datev_lauds.import.modals.confirm.description'
      )}
      illustration="alert"
      onClose={() => setConfirmModal(true)}
      footer={
        <>
          <Button type="secondary" onClick={() => setConfirmModal(false)}>
            {i18n.t('payroll_integrations.incidences.datev_lauds.import.buttons.go_back')}
          </Button>
          <Button onClick={saveEmployees}>
            {i18n.t('payroll_integrations.incidences.datev_lauds.import.buttons.confirm')}
          </Button>
        </>
      }
    />
  )
}

export default ConfirmModal
